import Sidebar from "./Sidebar";
import Header from "./Header";

export default function DashboardLayout({ children }) {
  return (
    <div className="min-h-screen bg-[#f8fafc]">
      <Sidebar />
      <Header />
      <main className="ml-[260px] px-8 py-6" data-testid="app-main">
        {children}
      </main>
    </div>
  );
}
